import React from "react";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { Space } from "@masterteam/mt-design-react";

import { useIsAr } from "../../../../../Hooks";

import "./style.scss";

function Year({ data = {}, frequency, statuses = [], HasNoTargetBaseline }) {
  const [, locale] = useIsAr();

  function getColVal(index, key) {
    const obj = data?.Data?.[index];
    const val = obj?.[key]?.toString() || "";

    if (["Value", "Variance"].includes(key)) {
      const statusObj = statuses?.find((e) => e?.Code === obj?.Status);

      if (obj?.IsLocked || obj?.Status === "NUV")
        return (
          <span style={{ fontSize: "12px" }}>
            <FormattedMessage id="common.not-measured" />
          </span>
        );
      return (
        <span
          style={{
            color: HasNoTargetBaseline
              ? "var(--primary-color)"
              : statusObj?.Color
          }}
        >
          {val}
        </span>
      );
    }

    return val;
  }

  function getSubHeaders() {
    let res = [];
    switch (frequency) {
      case "quarterly": {
        const months = data.Data?.filter((e) => !!e?.DueDate)?.map((e) =>
          new Date(e.DueDate).getMonth()
        );

        months.forEach((e) => {
          res.push(`Q${Math?.trunc(e / 3) + 1}`);
        });

        break;
      }

      case "annual":
        res = [data?.Year];
        break;

      case "semi-annual": {
        const months = data.Data?.filter((e) => !!e?.DueDate)?.map((e) =>
          new Date(e.DueDate).getMonth()
        );

        months.forEach((e) => {
          res.push(`H${Math?.trunc(e / 6) + 1}`);
        });
        break;
      }

      case "monthly": {
        const months = data.Data?.filter((e) => !!e?.DueDate)?.map(
          (e) => new Date(e.DueDate).getMonth() + 1
        );

        months.forEach((e) => {
          res.push(
            moment(`01-${e}-2023`, "DD-MM-YYYY").locale(locale).format("MMM")
          );
        });
        break;
      }

      case "custom": {
        const dates = data.Data?.filter((e) => !!e?.DueDate)?.map(
          (e) => new Date(e.DueDate)
        );

        dates.forEach((e) => {
          res.push(moment(e).locale(locale).format("DD-MMM"));
        });
        break;
      }

      default:
        res = [];
    }

    return res;
  }

  const subHeaders = getSubHeaders();

  return (
    <Space className="measures-table__year" direction="vertical" gap={0}>
      {frequency === "annual" ? null : (
        <Space className="measures-table__year__header">{data?.Year}</Space>
      )}
      <Space
        className="measures-table__year__sub-header"
        gap={0}
        style={{ borderTop: "1px solid var(--border-gray)" }}
      >
        {subHeaders?.map((e) => (
          <Space className="measures-table__year__sub-header__col">{e}</Space>
        ))}
      </Space>
      <Space className="measures-table__year__col" gap={0}>
        {subHeaders?.map((e, index) => (
          <Space className="measures-table__year__col__column">
            {getColVal(index, "Target")}
          </Space>
        ))}
      </Space>
      <Space className="measures-table__year__col" gap={0}>
        {subHeaders?.map((e, index) => (
          <Space className="measures-table__year__col__column">
            {getColVal(index, "Value")}
          </Space>
        ))}
      </Space>
      <Space className="measures-table__year__col" gap={0}>
        {subHeaders?.map((e, index) => (
          <Space className="measures-table__year__col__column">
            {getColVal(index, "Variance")}
          </Space>
        ))}
      </Space>
    </Space>
  );
}

export default Year;
